import { network } from '@utils'
import { DefaultQueryParams, PaginatedResponse, QueryFunction } from './root'

export type ChangeLogAction = 'create' | 'update' | 'delete'

export type ChangeLogResourceType =
  | 'document'
  | 'document_relation'
  | 'business'
  | 'invoice'
  | 'invoice_row'
  | 'entry'
  | 'purchase_invoice'
  | 'period'
  | 'vat_period'
  | 'business_usership'
  | 'account'
  | 'contact'
  | 'attachment'
  | 'tag'
  | 'workflow'

export type ChangeLogDiffOp = 'equal' | 'delete' | 'insert'

export interface IChangeLogActor {
  id: number | null
  email: string | null
  name: string | null
  is_staff?: boolean
}

export interface IChangeLogResource {
  type: ChangeLogResourceType
  type_label: string
  id: number
  label: string
  link?: {
    type: ChangeLogResourceType
    id: number
  } | null
}

export interface IChangeLogDiffSpan {
  op: ChangeLogDiffOp
  text: string
}

export interface IChangeLogValueRef {
  side: 'old' | 'new'
  type: ChangeLogResourceType
  id: number
  label: string
}

export interface IChangeLogFieldChange {
  field: string
  field_label: string
  old: string | null
  new: string | null
  display: string
  diff: IChangeLogDiffSpan[] | null
  refs?: IChangeLogValueRef[]
}

export interface IChangeLogEntry {
  id: string
  occurred_at: string
  action: ChangeLogAction
  actor: IChangeLogActor
  resource: IChangeLogResource
  change_reason: string | null
  client: string | null
  /** True when this is not a create and no earlier history row exists. */
  previous_untracked?: boolean
  changes: IChangeLogFieldChange[]
}

export interface ChangeLogListParams extends DefaultQueryParams {
  resource_type?: ChangeLogResourceType | 'all'
  action?: ChangeLogAction | 'all'
  from?: string
  to?: string
  actor_id?: number
  search?: string
}

interface ChangeLogListProps {
  slug: string
}

export const fetchChangeLog: QueryFunction<
  ChangeLogListProps,
  PaginatedResponse<IChangeLogEntry>
> = async ({ slug }, params = null) => {
  const url = `/v1/business/${slug}/change-log/`
  const { data } = await network.httpClient.request({
    url,
    method: 'GET',
    params
  })
  return data
}

export const fetchChangeLogActors: QueryFunction<ChangeLogListProps, IChangeLogActor[]> = async ({
  slug
}) => {
  const url = `/v1/business/${slug}/change-log/actors/`
  const { data } = await network.httpClient.request({
    url,
    method: 'GET'
  })
  return data
}
